import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function getOrganizationSummary(options = {}) {
  try {
    const organizationId =
      typeof options.organizationId === "string"
        ? options.organizationId.trim()
        : "";
    const query = organizationId
      ? `?organization_id=${encodeURIComponent(organizationId)}`
      : "";

    const response = await authFetch(
      `${BACKEND_URL}/organization/summary${query}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (!response.ok) {
      return {
        success: false,
        data: null,
        message: "조직 요약을 불러오지 못했습니다.",
      };
    }

    const payload = await response.json();

    return {
      success: payload?.success === true,
      data: payload?.data ?? null,
      message: payload?.message ?? "",
    };
  } catch (error) {
    console.error("[getOrganizationSummary] failed:", error);
    return {
      success: false,
      data: null,
      message: "조직 요약 요청 중 오류가 발생했습니다.",
    };
  }
}
